/**
 * Client UI features gated by the backend feature-toggle mechanism (LB-3784).
 * A feature is enabled unless its name is present in the auth token's excludedScope.
 * Values must match the feature `name` entries in the backend features.yaml.
 */
export enum ClientFeature {
  MarkoutReport = 'markoutReport',
  QuotesDashboard = 'quotesDashboard',
  ExternalReporting = 'externalReporting',
  TakerFixApi = 'takerFixApi',
  /** Basic pricing + trading bridge (default on); without it the trading pages are hidden (LB-4724) */
  BasicBridge = 'basicBridge',
  /** Independent markout: deals captured from external bridges for risk reporting (LB-4701) */
  RiskManagement = 'riskManagement',
}
